import React, { useState } from "react";
import { Bell } from "@semo/icons";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  HeaderActionButton,
} from "@semo/shared-ui";
import { useNotificationsControllerGetUnreadCount } from "@semo/api-contracts";
import {
  VendorNotificationContainer,
  type NotificationContainerChildProps,
} from "./VendorNotificationContainer";
import { NotificationDropdownView } from "./NotificationDropdownView";

interface VendorNotificationDropdownProps {
  onTabChange?: (tab: string) => void;
  /** 트리거 버튼 추가 클래스 (그라데이션 헤더용 글래스 스타일 등). */
  triggerClassName?: string;
  /** 종 아이콘 색 클래스 (기본 text-slate-600). */
  iconClassName?: string;
}

export const VendorNotificationDropdown: React.FC<
  VendorNotificationDropdownProps
> = ({ onTabChange, triggerClassName, iconClassName = "text-slate-600" }) => {
  const { data: unreadCountResponse } =
    useNotificationsControllerGetUnreadCount();
  const unreadCount = unreadCountResponse?.data?.notificationCount ?? 0;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <HeaderActionButton
          icon={<Bell className={`w-4 h-4 sm:w-5 sm:h-5 ${iconClassName}`} />}
          badgeCount={unreadCount}
          aria-label="알림"
          className={triggerClassName}
        />
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        className="w-[calc(100vw-24px)] max-w-[400px] p-0 border border-slate-200 shadow-xl"
      >
        <VendorNotificationContainer type="dropdown" onTabChange={onTabChange}>
          {(props: NotificationContainerChildProps) => (
            // 알림 센터 화면이 아직 없어 «알림 센터로 이동» 버튼을 두지 않는다(누르면 «준비 중»
            // 만 뜨던 미구현 버튼 — V-15).
            <NotificationDropdownView {...props} />
          )}
        </VendorNotificationContainer>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
